// import React from 'react';

export const highlightNavigatedMenu = (newPath, oldPath) => {
  const activeLi = $('a[href="#/app/components/' + newPath + '"]');
  const inactiveLi = $('a[href="' + oldPath + '"]');

  inactiveLi.parent().removeClass('open');
  activeLi.parent().addClass('open');
};



// WEBPACK FOOTER //
// ./util/highlightSidebarOption.js